<template>
  <div class="my-spin">
    <a-spin size="large"></a-spin>
  </div>
</template>

<script>
export default {
  name: 'my-spin',

  data() {
    return {}
  }
}
</script>

<style scoped lang="less">
.my-spin {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  // margin-top: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 9999;
}
</style>
